import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RequestService } from 'Utils/Api';

export const getServiceStatus = (url) => RequestService.send({ url, method: 'GET' });

// return component with check service status call
export const withServicesStatus = (WrappedComponent) => {
  return function ServiceStatusHoc(props) {
    const { enableServiceCheck, serviceStatusPath, serviceFailureRedirectUrl } = useSelector(
      (s) => s.appConfig.defaultConfig
    );

    useEffect(() => {
      const checkServiceStatus = async () => {
        try {
          const {
            status,
            data: { maintenance = null },
          } = await getServiceStatus(serviceStatusPath);
          if (status !== 200 && maintenance) {
            window.location.replace(serviceFailureRedirectUrl);
            return;
          }
          console.debug('serviceFailure lookup: OK');
        } catch (e) {
          console.debug(`serviceFailure lookup: `, e.message);
        }
      };

      if (enableServiceCheck) checkServiceStatus();
    }, [enableServiceCheck, serviceStatusPath, serviceFailureRedirectUrl]);

    return <WrappedComponent {...props} />;
  };
};
